import CreateGamePage from './CreateGame';

export default CreateGamePage;
